// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-message-container {
  padding: 10px 28px 16px;
  position: relative;
  z-index: 2;
  /* Overlap the faded bottom of the messages so text dissolves into the input. */
  margin-top: -20px;
  /* Center to the same reading column as the messages (see .message-inner). */
  width: 100%;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
}

/* Small disclaimer under the input, centered to the column. */
.input-disclaimer {
  text-align: center;
  font-size: 11px;
  color: #98a4ad;
  margin-top: 8px;
}

.input-message-wrapper {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  background: #ffffff;
  border: 1px solid #d9e0e4;
  border-radius: 16px;
  padding: 11px 14px;
  box-shadow: 0 4px 14px rgba(0, 49, 79, 0.08);
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  outline: none;
  direction: ltr; /* keep send button on right regardless of global RTL */
}

.input-message-wrapper:focus-within {
  border-color: #00314f;
  box-shadow: 0 6px 22px rgba(0, 49, 79, 0.18);
}

.input-message-textarea {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  resize: none;
  padding: 6px 0;
  min-height: 20px;
  max-height: 150px;
  /* Auto-grows via JS; hide the scrollbar until content actually exceeds the
     max height (the JS flips this to auto), so a wrapped placeholder at narrow
     widths doesn't show a scrollbar. */
  overflow-y: hidden;
  font-size: 14px;
  line-height: 1.5;
  font-family: inherit;
}

.input-message-textarea:focus {
  outline: none;
}

.input-message-textarea::placeholder {
  /* Theme-aware slate (set from the component); darker than before so the
     prompt reads clearly against the white pill. */
  color: var(--ph-color, #5c6d77);
  opacity: 1;
}

.send-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 10px;
  /* Full teal in every state to match the mock. */
  background: #1D9E98;
  cursor: not-allowed;
  transition: all 0.2s ease;
  padding: 0;
  margin-bottom: 2px;
}

.send-button.active {
  background: #1D9E98;
  cursor: pointer;
}

.send-button.active:hover {
  background: #178b85;
  transform: scale(1.05);
}

.send-button svg {
  width: 16px;
  height: 16px;
  stroke: #ffffff;
  transition: all 0.2s ease;
}


.suggestions-container{
  margin-bottom: 1rem;
}
.suggestion-bubble {
  background-color: #f0f0f0;
  border: none;
  border-radius: 16px;
  height: auto;
  padding: 5px 8px;
  font-size: 0.82rem;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}

.suggestion-bubble:hover {
  background-color: #1e2e38;
  color: #fff;
}

.stop-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background: #e53935;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s;
  padding: 0;
  margin-bottom: 2px;
  flex-shrink: 0;
}

.stop-button:hover {
  background: #c62828;
  transform: scale(1.08);
}

.stop-button svg {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/InputMessage/InputMessage.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,+EAA+E;EAC/E,iBAAiB;EACjB,4EAA4E;EAC5E,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,wDAAwD;EACxD,aAAa;EACb,cAAc,EAAE,uDAAuD;AACzE;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB;;uCAEqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;mDACiD;EACjD,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;EAChD,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;;AAGA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".input-message-container {\n  padding: 10px 28px 16px;\n  position: relative;\n  z-index: 2;\n  /* Overlap the faded bottom of the messages so text dissolves into the input. */\n  margin-top: -20px;\n  /* Center to the same reading column as the messages (see .message-inner). */\n  width: 100%;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n  box-sizing: border-box;\n}\n\n/* Small disclaimer under the input, centered to the column. */\n.input-disclaimer {\n  text-align: center;\n  font-size: 11px;\n  color: #98a4ad;\n  margin-top: 8px;\n}\n\n.input-message-wrapper {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  background: #ffffff;\n  border: 1px solid #d9e0e4;\n  border-radius: 16px;\n  padding: 11px 14px;\n  box-shadow: 0 4px 14px rgba(0, 49, 79, 0.08);\n  transition: box-shadow 0.2s ease, border-color 0.2s ease;\n  outline: none;\n  direction: ltr; /* keep send button on right regardless of global RTL */\n}\n\n.input-message-wrapper:focus-within {\n  border-color: #00314f;\n  box-shadow: 0 6px 22px rgba(0, 49, 79, 0.18);\n}\n\n.input-message-textarea {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  resize: none;\n  padding: 6px 0;\n  min-height: 20px;\n  max-height: 150px;\n  /* Auto-grows via JS; hide the scrollbar until content actually exceeds the\n     max height (the JS flips this to auto), so a wrapped placeholder at narrow\n     widths doesn't show a scrollbar. */\n  overflow-y: hidden;\n  font-size: 14px;\n  line-height: 1.5;\n  font-family: inherit;\n}\n\n.input-message-textarea:focus {\n  outline: none;\n}\n\n.input-message-textarea::placeholder {\n  /* Theme-aware slate (set from the component); darker than before so the\n     prompt reads clearly against the white pill. */\n  color: var(--ph-color, #5c6d77);\n  opacity: 1;\n}\n\n.send-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 10px;\n  /* Full teal in every state to match the mock. */\n  background: #1D9E98;\n  cursor: not-allowed;\n  transition: all 0.2s ease;\n  padding: 0;\n  margin-bottom: 2px;\n}\n\n.send-button.active {\n  background: #1D9E98;\n  cursor: pointer;\n}\n\n.send-button.active:hover {\n  background: #178b85;\n  transform: scale(1.05);\n}\n\n.send-button svg {\n  width: 16px;\n  height: 16px;\n  stroke: #ffffff;\n  transition: all 0.2s ease;\n}\n\n\n.suggestions-container{\n  margin-bottom: 1rem;\n}\n.suggestion-bubble {\n  background-color: #f0f0f0;\n  border: none;\n  border-radius: 16px;\n  height: auto;\n  padding: 5px 8px;\n  font-size: 0.82rem;\n  cursor: pointer;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.suggestion-bubble:hover {\n  background-color: #1e2e38;\n  color: #fff;\n}\n\n.stop-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 50%;\n  background: #e53935;\n  cursor: pointer;\n  transition: background 0.2s, transform 0.15s;\n  padding: 0;\n  margin-bottom: 2px;\n  flex-shrink: 0;\n}\n\n.stop-button:hover {\n  background: #c62828;\n  transform: scale(1.08);\n}\n\n.stop-button svg {\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
